import {
	fetchAllOrderHistory,
	fetchAllOrders,
	fetchAllPositions,
	fetchAllTrades,
	fetchPaginatedOrderHistory,
	fetchTradesPaginated
} from '$lib/apis/userHoldings';
import {
	// firstTimeFetchingOrders,
	// firstTimeFetchingPositions,
	positions,
	orders,
	// fetchingPositions,
	// fetchingOrders,
	paginatedTrades,
	fetchingPaginatedData,
	currentPageTrades,
	fetchingPaginatedOrderHistory,
	currentPageOrderHistory,
	paginatedOrderHistory,
	fetchingTrades,
	firstTimeFetchingTrades,
	recentFewOrderHistory
} from '$lib/home/store';
import type { PaginatedTrades, Trade } from '$lib/types/trade';
import type { Order, PaginatedOrders } from '$lib/types/order';
import type { Position } from '$lib/types/position';
import { get } from 'svelte/store';
import { fetchAllMargin } from '$lib/apis/userInteract';
import { firstLoadedMargin, userMarginList } from '$lib/home/userInteract/store';
import type { UserMargin } from '$lib/types/user';
import { getOrderIdUI } from '$lib/util/util';
import { TRADES_PER_PAGE } from '$lib/home/constants';
import { smartContractWalletAddress } from '$lib/home/scwallet/store';

export async function getAllOrderHistory() {
	const data: Order[] = (await fetchAllOrderHistory(get(smartContractWalletAddress))) as Order[];
	return data;
}

export async function getAllTrades() {
	fetchingTrades.set(true);
	const data: Trade[] = (await fetchAllTrades(get(smartContractWalletAddress))) as Trade[];
	if (get(firstTimeFetchingTrades)) {
		firstTimeFetchingTrades.set(false);
	}
	fetchingTrades.set(false);
	return data;
}

export async function getPaginatedOrderHistory() {
	fetchingPaginatedOrderHistory.set(true);
	const data: PaginatedOrders = (await fetchPaginatedOrderHistory(
		get(currentPageOrderHistory),
		TRADES_PER_PAGE,
		get(smartContractWalletAddress)
	)) as PaginatedOrders;
	paginatedOrderHistory.set(data);

	const recent: PaginatedOrders = (await fetchPaginatedOrderHistory(
		1,
		10,
		get(smartContractWalletAddress)
	)) as PaginatedOrders;

	if (recent) {
		recent.orders.forEach((e) => {
			e.orderIdUi = getOrderIdUI(e);
		});
		recentFewOrderHistory.set(recent);
	}
	fetchingPaginatedOrderHistory.set(false);
}

export async function getPaginatedTrades() {
	fetchingPaginatedData.set(true);
	let data: PaginatedTrades = (await fetchTradesPaginated(
		get(currentPageTrades),
		TRADES_PER_PAGE,
		get(smartContractWalletAddress)
	)) as PaginatedTrades;
	fetchingPaginatedData.set(false);
	paginatedTrades.set(data);
}

export async function getAllMarginsForAllMarkets() {
	let margins = (await fetchAllMargin()) as UserMargin[];
	userMarginList.set(margins);
	firstLoadedMargin.set(true);
}
